import type { ScopeKey } from 'common/scope/scope';

export const performanceAssessmentKeys = {
  all: ['performanceAssessments'] as const,

  lists: () => [...performanceAssessmentKeys.all, 'list'],

  adminList: (enabled: boolean) => [...performanceAssessmentKeys.lists(), 'admin', enabled],

  providerLists: () => [...performanceAssessmentKeys.lists(), 'provider'],

  providerList: (scopeKey: ScopeKey) => [...performanceAssessmentKeys.providerLists(), ...scopeKey],

  teacherList: (schoolClassId?: number) => [...performanceAssessmentKeys.lists(), 'teacher', schoolClassId ?? null],
};
